// extracted by mini-css-extract-plugin
export default {"BlockLayout":"Layout_BlockLayout__-dCQc","BlockLayoutSpinner":"Layout_BlockLayoutSpinner__4lJ8Y"};